import { useState, useRef } from "react";
import "./ImageZoom.css";

const ImageZoom = ({ src, alt, style }) => {
  const [isZoomed, setIsZoomed] = useState(false);
  const divElement = useRef(null);
  const [zoomPosition, setZoomPosition] = useState({ x: 0, y: 0 });
  const [isZoomedLeft, setIsZoomedLeft] = useState(false);

  const handleMouseMove = (e) => {
    if (!divElement.current) return;
    const { left, top, width, height } = divElement.current.getBoundingClientRect();
    const x = ((e.clientX - left) / width) * 100;
    const y = ((e.clientY - top) / height) * 100;

    setZoomPosition({ x, y });
    setIsZoomedLeft(left - 440 > window.innerWidth / 5);
  };

  return (
    <div
      ref={divElement}
      className="image-zoom-container"
      onMouseEnter={() => window.innerWidth >= 640 && setIsZoomed(true)}
      onMouseLeave={() => setIsZoomed(false)}
      onMouseMove={handleMouseMove}
    >
      <img style={{ width: "100%", ...style }} src={src} alt={alt} className="image-zoom" />
      {isZoomed && (
        <div
          className="zoomed-image"
          style={{
            backgroundImage: `url(${src})`,
            backgroundPosition: `${zoomPosition.x}% ${zoomPosition.y}%`,
            left: isZoomedLeft ? "auto" : "100%",
            right: isZoomedLeft ? "100%" : "auto",
            transform: isZoomedLeft ? "translateX(-20px)" : "none",
          }}
        />
      )}
    </div>
  );
};

export default ImageZoom;
